import React, { useMemo, useContext } from 'react';
import { useDispatch } from 'react-redux';
import ProductImage from '@prisjakt/ui-product-image';
import { AppContext } from '@prisjakt/ui-app-context';
import Lazy from '../../../../components/lazy';
import { productPriceClick } from '../../../product/actions/product';
import { OffersSlice } from '../../../../types';
import HighlightedSearchResult from '../products/highlighted-search-result';
import OfferCard from './offer-card';

type Props = {
  offer: OffersSlice['offers'][0];
};

const Offer = ({ offer }: Props) => {
  const { t, linkTo } = useContext(AppContext);
  const dispatch = useDispatch();
  const title = t('product', 'store.link');
  const price = offer.offerPrice && offer.offerPrice.regular;
  const image = useMemo(
    () => (
      <Lazy offset={0}>
        <ProductImage name={offer.name} src={offer.media.first || ''} />
      </Lazy>
    ),
    [offer.name, offer.media.first]
  );
  return (
    <OfferCard
      name={offer.name}
      highlightedName={
        offer.highlight ? (
          <HighlightedSearchResult>{offer.highlight}</HighlightedSearchResult>
        ) : (
          undefined
        )
      }
      image={image}
      price={price}
      storeName={offer.store.name}
      storeId={offer.store.id}
      storePageLink={linkTo('store', offer.store)}
      stockStatus={offer.stockStatus}
      goToStoreText={title}
      hasStoreLogoImage={!!offer.store.hasLogo}
      featured={!!offer.store.featured}
      externalUri={offer.externalUri}
      onClickGoToStore={() =>
        dispatch(
          productPriceClick(
            null,
            price,
            !!offer.store.featured,
            'offerCollection'
          )
        )
      }
    />
  );
};

export default Offer;
